import { AxiosResponse } from 'axios'
import isEmpty from 'lodash/isEmpty'
import { IFilter, IWhere } from 'types/common'
import { api } from 'API'
import { IMessageGroup, IThreadGroup, IMessageGroupThreads, IGroupMessages } from 'interfaces/message'

export async function getGroupMessageThreads(filter: IFilter<IMessageGroup> = {}): Promise<IMessageGroup[]> {
  const response: AxiosResponse = await api.get(`/group-message-threads?filter=${JSON.stringify(filter)}`)
  return response.data
}

export async function getGeneralMessageThreads(limit: number, keyword: string): Promise<IMessageGroupThreads[]> {
  const response: AxiosResponse = await api.get(`/group-message-threads/general-messages`, {
    params: { limit, keyword }
  })
  return response.data
}

export async function getCountGroupMessageThreads(where: IWhere<IMessageGroup> = {}): Promise<number> {
  const response: AxiosResponse = await api.get(`/group-message-threads/count?where=${JSON.stringify(where)}`)
  return +(response.data.count ?? 0)
}

export async function createGroupMessageThreads(threadGroup: IThreadGroup): Promise<number> {
  const resp = await api.post('/group-message-threads', threadGroup)
  return resp.data.id
}

export async function countAllUnreadGroupThread(): Promise<number> {
  const response: AxiosResponse = await api.get(`/group-message-threads/count-all-notification`)
  return +(response?.data ?? 0)
}

export async function getAllUnreadGeneralMessages(): Promise<IMessageGroupThreads[]> {
  const response: AxiosResponse = await api.get(`/group-message-threads/get-all-unread-messages`)
  return response?.data ?? []
}

export async function createGroupMessageThreadsGroup(
  groupThreadId: number,
  groupIds?: number[]
): Promise<IMessageGroupThreads | null> {
  if (isEmpty(groupIds)) {
    return null
  }
  const resp = await api.post('/group-message-thread-groups/batch', { groupThreadId, groupIds })
  return resp.data
}

export async function createGroupMessageThreadsUser(
  groupThreadId: number,
  userIds?: number[]
): Promise<IMessageGroupThreads | null> {
  if (isEmpty(userIds)) {
    return null
  }
  const resp = await api.post('/group-message-thread-users/batch', { groupThreadId, userIds })
  return resp.data
}

export function createMessageThreads(threadGroupId: number, messageThreads: any): Promise<IMessageGroupThreads> {
  return api.post(`/group-message-threads/${threadGroupId}/group-messages`, messageThreads)
}

export async function validateUserOnThread(threadGroupId: number, userId: number): Promise<boolean> {
  const response = await api.get(`/group-message-threads/${threadGroupId}/user/${userId}/validate`)
  return response.data
}

export async function getMessages(threadId: number, filter: IFilter<IMessageGroup> = {}): Promise<IGroupMessages[]> {
  const res = await api.get(`/group-message-threads/${threadId}?filter=${JSON.stringify(filter)}`)
  return res.data
}

export async function getExistingThread(participantIds: number[]): Promise<number> {
  const res = await api.get(
    `/group-message-threads-users/get-existing?participantIds=${JSON.stringify(participantIds)}`
  )
  return res.data
}
